import React, { FC, useCallback, useState } from 'react';

import { Flex } from 'Src/components/layout/Flex';
import { useDOMEventListener } from 'Src/feature/dom-event/useDOMEventListener';

import LocationSelector from './LocationSelector';
import OrgSelector from './OrgSelect';
import { useEmailWorkflow } from './useEmailWorkflow';

const OrganizationAndLocationSelector: FC = () => {
  const workflow = useEmailWorkflow();

  const [isSelectingOrg, isSelectingOrgSet] = useState(!workflow.data.organizationId);

  useDOMEventListener('emailWorkflow.onGoPrev', useCallback((evt) => {
    if (!isSelectingOrg) {
      // if not currently selecting org, we must be in location selection
      evt.preventDefault();
      workflow.updateData({
        locationId: null,
        locations: [],
      });
      isSelectingOrgSet(true);
      // if only one org to pick from, we should go all the way back
      // instead of stopping at org-select
      if (workflow.data.organizations.length === 1) {
        return workflow.steps.goPrev();
      }
    } else {
      // else, we're in org selection and need to just go back to prior top-level step in workflow
      workflow.updateData({
        organizationId: null,
      });
    }
  }, [workflow, isSelectingOrg]));

  useDOMEventListener('emailWorkflow.onGoNext', useCallback((evt) => {
    // if currently selecting org, just need to move on to loc selection
    if (isSelectingOrg) {
      evt.preventDefault();
      isSelectingOrgSet(false);
      return;
    }
  }, [isSelectingOrg]));

  return (
    <Flex alignItems="center" justifyContent="center" gap="sm" fullHeight fullWidth>
      {!isSelectingOrg ? <LocationSelector /> : <OrgSelector />}
    </Flex>
  );
};

export { OrganizationAndLocationSelector };
